module.exports = __webpack_public_path__ + "img/img-7mobile.8e66c7b5.webp";